<template>
    <li class="md-testimionial comment-item" viewmore-container>
        <div class="comment-top">
            <div class="comment-head" aria-hidden="true">
                <img-box
                    v-if="theme === 'default' && userComment.avatarLink"
                    class="img-box"
                    :src="userComment.avatarLink"
                />
                <span class="head-txt">{{ nameFirstLetter }}</span>
            </div>
            <div class="name-star">
                <div
                    class="comment-name"
                    v-html="userComment.reviewerName"
                ></div>
                <div class="score-container">
                    <ReviewScore
                        :onlyShowActiveScore="false"
                        :sourceType="userComment.sourceType"
                        :score="userComment.reviewRate"
                        :iconSize="18"
                    />
                    <slot></slot>
                </div>
            </div>
        </div>
        <div class="comment-box">
            <!-- TODO: exist  xss  Risk needs to be confirmed  -->
            <view-more
                class="content"
                :content="userComment.reviewContent"
                :moreText="$t('common:readMore')"
                :line="moreLine"
                :mobileLine="mobileMoreLine"
                @click.stop
            ></view-more>
            <img-box
                v-if="theme === 'online' && userComment.avatarLink"
                class="comment-img"
                aria-hidden="true"
                :src="userComment.avatarLink"
            />
            <comment-share
                v-show="enableShare"
                class="share"
                :facebookUrl="`https://www.facebook.com/share.php?u=${url}?recommendId=${userComment.id}`"
                :linkedinUrl="`https://www.linkedin.com/shareArticle?mini=true&url=${url}?recommendId=${userComment.id}`"
                :twitterUrl="`https://twitter.com/share?text=${$t(
                    'md-testimonial.hereIsARecommendation'
                )}&url=${url}?recommendId=${userComment.id}`"
                :gmailUrl="`mailTo:?&subject=${$t(
                    'md-testimonial.pleaseTakeALook'
                )}&body=Hi , ${$t(
                    'md-testimonial.hereIsARecommendation'
                )}${url}?recommendId=3640266`"
            ></comment-share>
        </div>
        <div class="comment-time">
            <only-client>{{ $ft.formatDate(userComment.reviewTime, 'MMM dd yyyy') }}</only-client>
        </div>
    </li>
</template>

<script>
import ReviewScore from '../review-score.vue';
import commentShare from './comment-share.vue';
import viewMore from '@/components/view-more.vue';

export default {
    name: 'comment',
    i18next: {
        ns: 'md-testimonial'
    },
    components: {
        ReviewScore,
        commentShare,
        viewMore
    },
    props: {
        moreLine: {
            type: Number,
            default: 5
        },
        mobileMoreLine: {
            type: Number,
            default: 5
        },
        userComment: {
            type: Object
        },
        theme: {
            type: String,
            default: 'default'
        },
        enableShare: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        nameFirstLetter() {
            let userName = this.userComment?.reviewerName || '';
            return userName.charAt(0) || '';
        }
    },
    data: function() {
        return {
            showShare: true,
            url: this.pageLocation.href
        };
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-testimionial.comment-item {
    margin-top: 20px;
    position: relative;
    .comment-top {
        display: flex;
        .comment-head {
            position: relative;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 22px;
            .img-box {
                width: 60px;
                height: 60px;
            }
            .head-txt {
                display: block;
                width: 100%;
                height: 100%;
                background-color: #d9d9d9;
                text-align: center;
                font-size: 36px;
                color: #fff;
                text-transform: uppercase;
                line-height: 60px;
            }
        }
        .comment-name {
            font-family: var(--font-bold);
            font-size: 20px;
            color: #282828;
            padding-right: 90px;
            min-height: 29px;
        }
        .name-star {
            flex: 1;
            .score-container {
                display: flex;
                justify-content: space-between;
                padding-top: 10px;
            }
        }
    }
    .comment-box {
        margin-top: 8px;
        padding-left: 82px;
        border-bottom: 1px solid #e6e6e6;
        .content {
            font-size: 15px;
            line-height: 20px;
            color: #282828;
            .more-btn {
                margin-top: 4px;
                @include color-theme();
            }
        }
        .comment-img {
            margin-top: 10px;
            width: 420px;
            height: 240px;
            overflow: hidden;
            position: relative;
        }
        .share {
            padding: 10px 0 20px;
        }
        @include media-600 {
            padding-left: 0;
            .comment-img {
                width: auto;
                height: 200px;
            }
        }
    }

    .comment-time {
        position: absolute;
        right: 0;
        top: 5px;
        font-size: 14px;
        color: #c8c8c8;
    }
}
</style>
